import React, { Component } from 'react';
import { getWindow } from "Pub/js/utils";


export default class OpenApp extends Component {
    constructor(props) {
        super(props);
    }
    getParameter = () => {
        // const url = 'http://127.0.0.1/#/openapp?appcode=10120USRM&menuitemcode=10120210'
        // const url = 'http://127.0.0.1:81/#/openapp?menucode=20001902'
        const url = getWindow().location.href;
        const params = url && url.split('?')[1] && url.split('?')[1].split('&');
        const obj = {};
        params.forEach((item => {
            obj[item.split('=')[0]] = item.split('=')[1];
        }))
        return obj;
    }
    componentDidMount() {
        const type = 'current';
        const appOption = this.getParameter();
        if (appOption && appOption.menucode === "20001902") {
            //  跳首页 注册首页的 menuitemcode
            this.props.history.replace('/');
        } else {
            window.openNew(appOption, type);
        }
    }
    render() {
        return null
    }
}
